import Smartphones from 'Todo/views/TodoView/containers/Smartphones'
import Tablets from 'Todo/views/TodoView/containers/Tablets'

import {getCurrentDeviceView} from 'shared/helpers/utils'

const TodoView = getCurrentDeviceView(Smartphones, Tablets)

export default TodoView
